<template>
  <div class="container pt-4">
    <h1 class="mb-4">{{$t('CONTENT.aboutPage.about')}}</h1>
    <div class="about__block p-6">
      <p class="pb-4">{{$t('CONTENT.aboutPage.copyright')}}</p>
      <p class="pb-4">{{$t('CONTENT.aboutPage.registration')}}</p>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    version() {
      return window.ENV.VERSION
    }
  }
};
</script>

<style>
.about__block {
  background: #fff;
  box-shadow: 0 1px 3px 0 rgb(157 157 157 / 50%);
}
</style>
